








import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation } from "vuex-class";

import PaymentsTable from "@/components/falcon/payments/PaymentsTable.vue";
import PaymentsForms from "@/components/falcon/payments/PaymentsForms.vue";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";
import { capitalizeFilter } from "@/filters/capitalize.filter";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payments view component
 */
@Component({
  components: { PaymentsForms, PaymentsTable },
  filters: {
    ...capitalizeFilter
  }
})
export default class PaymentsView extends Vue {
  @Watch("$i18n.locale") private localeUpdated(): void {
    this.setTranslatedTitlePrefix();
  }
  @Mutation("app/setTitlePrefix") setTitlePrefix!: (newPrefix: string) => void;

  i18nMessageKeyEnum = I18nMessageKey;

  created(): void {
    this.setTranslatedTitlePrefix();
  }

  private setTranslatedTitlePrefix(): void {
    this.setTitlePrefix(
      capitalizeFilter.capitalize(
        this.$t(this.i18nMessageKeyEnum.PaymentsModuleTitleText)
      )
    );
  }
}
